export default {
  error (state) {
    return state.error
  },
  loading (state) {
    return state.loading
  },
  isAuthenticated (state) {
    return state.user !== null && state.user !== undefined
  },
  user (state) {
    return state.user
  },
  token (state) {
    return state.token
  },
  userAccountDetails (state, getters) {
    const accountDetails = {
      company: '',
      phone: '',
      logo: '',
      address: {
        street: '',
        street2: '',
        city: '',
        state: '',
        zip: '',
        country: 'US'
      }
    }
    if (getters.isAuthenticated) {
      const {user} = getters
      Object.keys(accountDetails).forEach((key) => {
        accountDetails[key] = user[key] || accountDetails[key]
      })
    }
    return accountDetails
  },
  apiKeys (state, getters) {
    return getters.isAuthenticated && (getters.user.keys || []).map((key) => ({
      ...key,
      created: key.created && key.created.toDate() || undefined,
      updated: key.updated && key.updated.toDate() || undefined
    })) || []
  },
  receipts (state) {
    return state.receipts.data || []
  },
  totalReceipts (state, getters) {
    return getters.isAuthenticated && getters.user.total || 0
  },
  stripeCustomerLoading (state, getters) {
    return state.stripe.status.customer.loading
  },
  stripeCustomerProcessing (state, getters) {
    return state.stripe.status.customer.processing
  },
  stripeCardLoading (state, getters) {
    return state.stripe.status.card.loading
  },
  stripeCardProcessing (state, getters) {
    return state.stripe.status.card.processing
  },
  stripeSubscriptionLoading (state, getters) {
    return state.stripe.status.subscription.loading
  },
  stripeSubscriptionProcessing (state, getters) {
    return state.stripe.status.subscription.processing
  },
  stripeInvoicesLoading (state, getters) {
    return state.stripe.status.invoices.loading
  },
  stripeInvoicesProcessing (state, getters) {
    return state.stripe.status.invoices.processing
  },
  stripeLoading (state, getters) {
    return getters.stripeCustomerLoading || getters.stripeCardLoading || getters.stripeInvoicesLoading
  },
  stripeProcessing (state, getters) {
    return getters.stripeCustomerProcessing || getters.stripeCardProcessing || getters.stripeInvoicesProcessing
  },
  stripeCards (state) {
    return state.stripe.cards.data || []
  },
  stripeCardsHasMore (state) {
    return state.stripe.cards.hasMore
  },
  stripeInvoices (state) {
    return state.stripe.invoices.data || []
  },
  stripeInvoicesHasMore (state) {
    return state.stripe.invoices.hasMore
  },
  stripeCustomer (state) {
    return state.stripe.customer
  },
  stripeSubscription (state) {
    return state.stripe.subscription
  },
  stripeCard (state) {
    return state.stripe.card
  }
}
